import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
import { kitModules } from '../../data/landing';
import { ModuleCover } from '../ModuleCover';
export function ModulesSection() {
  const [active, setActive] = useState(0);
  const mod = kitModules[active];
  const total = kitModules.length;
  const go = (dir: 1 | -1) => setActive(a => (a + dir + total) % total);
  return <section id="modulos" className="bg-beige-100 py-12 sm:py-24" data-id="element-211" data-mp="2128kjyd8pf0o">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-212" data-mp="212ichrhuhw90">
        <div className="mx-auto max-w-2xl text-center" data-id="element-213" data-mp="2611uxhx8cpwm">
          <h2 className="font-serif text-[1.9rem] leading-tight text-petrol-800 text-balance sm:text-5xl" data-id="element-214" data-mp="25zig7vr82mwy">
            Todo lo que tenés dentro de <span className="italic text-terra-500" data-id="element-215" data-mp="1ddfugijau1dz">Kit Sexualidad Práctica</span>
          </h2>
          <p className="mt-3 text-[15px] text-ink/70 sm:mt-5 sm:text-lg" data-id="element-216" data-mp="1ib7ih1gtp3cw">
            <strong className="text-petrol-800" data-id="element-217" data-mp="1epgngxbho53o">7 módulos completos</strong> pensados para acompañar diferentes etapas de la práctica
            profesional. <span className="text-terra-600" data-id="element-218" data-mp="19rolfah4r2lr">Tocá cada módulo para explorarlo.</span>
          </p>
        </div>

        {/* Selector de portadas */}
        <div role="tablist" aria-label="Módulos del kit" className="no-scrollbar -mx-5 mt-7 flex snap-x gap-3 overflow-x-auto px-5 pb-4 pt-3 sm:-mx-8 sm:mt-12 sm:px-8 lg:-mx-10 lg:grid lg:grid-cols-7 lg:gap-4 lg:overflow-visible lg:px-0" data-id="element-219" data-mp="10y1srt87yfgs">
          {kitModules.map((m, i) => {
          const selected = i === active;
          return <button key={m.number} type="button" role="tab" aria-selected={selected} aria-controls="module-detail" onClick={() => setActive(i)} className={`relative w-[38%] shrink-0 snap-start rounded-lg text-left transition-[transform,opacity] duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terra-500 sm:w-[24%] lg:w-auto ${selected ? '-translate-y-1.5 scale-[1.03] opacity-100' : 'opacity-80 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-220" data-mp="m09f76m8g158" data-mpi={i}>
                <ModuleCover module={m} data-id="element-221" data-mp="eh05fc9te0fn" />
                {selected && <motion.span layoutId="module-indicator" transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="absolute -bottom-2.5 left-1/2 h-1 w-8 -translate-x-1/2 rounded-full bg-terra-500" data-id="element-222" data-mp="eiuqcql35sjq" />}
                {m.number === 7 && <span className="absolute -right-1.5 -top-2 flex h-6 w-6 items-center justify-center rounded-full bg-terra-500 text-cream shadow" data-id="element-223" data-mp="sgt17m0776uh">
                    <StarIcon className="h-2.5 w-2.5 fill-current" aria-hidden="true" data-id="element-224" data-mp="xe1kxr0zvixu" />
                    <span className="sr-only" data-id="element-225" data-mp="jg38ir68hwkz">Destacado</span>
                  </span>}
              </button>;
        })}
        </div>

        {/* Detalle del módulo */}
        <div id="module-detail" role="tabpanel" className="mt-5 overflow-hidden rounded-2xl bg-paper shadow-[0_24px_50px_-36px_rgba(17,43,42,0.5)] sm:mt-8" data-id="element-226" data-mp="345ka3b6wkb1y">
          <AnimatePresence mode="wait" initial={false} data-id="element-227" data-mp="30oo788kyweaq">
            <motion.div key={mod.number} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid items-center gap-5 p-5 sm:grid-cols-[240px_1fr] sm:gap-10 sm:p-8 lg:grid-cols-[300px_1fr]" data-id="element-228" data-mp="30n3bifmx2pba">
              <div className="hidden sm:block" data-id="element-229" data-mp="2hvtznzpobogj">
                <ModuleCover module={mod} size="lg" data-id="element-230" data-mp="2d04y5qu3fxhl" />
              </div>
              <div data-id="element-231" data-mp="2rohwuvkkfufs">
                <div className="flex items-center justify-between gap-3" data-id="element-232" data-mp="2rp1f6de4okuc">
                  <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-terra-600" data-id="element-233" data-mp="2mxjbhhkq065o">
                    Módulo {mod.number} de {total}
                    {mod.number === 7 && <span className="ml-2 text-sage-700" data-id="element-234" data-mp="1z5cau67ypd0g">· Destacado</span>}
                  </p>
                  <div className="flex gap-1.5" data-id="element-235" data-mp="1u6rmp55zijsd">
                    <button type="button" onClick={() => go(-1)} aria-label="Módulo anterior" className="flex h-8 w-8 items-center justify-center rounded-full border border-beige-300 text-petrol-800 transition-colors duration-150 ease-out hover:bg-beige-100" data-id="element-236" data-mp="xia1mobhi7gv">
                      <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-237" data-mp="1b8ltqn82k680" />
                    </button>
                    <button type="button" onClick={() => go(1)} aria-label="Módulo siguiente" className="flex h-8 w-8 items-center justify-center rounded-full bg-petrol-800 text-cream transition-colors duration-150 ease-out hover:bg-petrol-700" data-id="element-238" data-mp="1g7ysa58az1qf">
                      <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-239" data-mp="1q6e8ve9peslo" />
                    </button>
                  </div>
                </div>
                <h3 className="mt-2 font-serif text-2xl leading-tight text-petrol-800 sm:text-4xl" data-id="element-240" data-mp="3rxj0497q5r5h">
                  {mod.title} {mod.subtitle}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-ink/70 sm:mt-3 sm:text-lg" data-id="element-241" data-mp="3w0xeywjxg1hc">{mod.description}</p>
                <ul className="mt-4 flex flex-wrap gap-2" data-id="element-242" data-mp="3oh69q7so7qkw">
                  {mod.includes.map(item => <li key={item} className="flex items-center gap-1.5 rounded-full bg-sage-100 px-3 py-1.5 text-[13px] font-medium text-petrol-800" data-id="element-243" data-mp="3jminkfl5389h">
                      <CheckIcon className="h-3.5 w-3.5 text-terra-500" strokeWidth={3} aria-hidden="true" data-id="element-244" data-mp="3aoq89bff40m3" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}